
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { setResultModalData, showModal } from "../modal/modalSlice";
import axiosInstance from "../../axios/axiosInstance";

const initialState = {
    isLoadingGetSetttings: false,
    settingsData: null,

    isLoadingUpdateSettings: false,

    toBeUpdatedAdminSettingsData: null,

    //! SSS

    
    SSSList: [
        {
          id: "1",
          question: "Kamyoon Nedir?",
          answer: "Sistemde teslim adresi kayıtlı değilse, teslimat, *ürün sevk irsaliyesinde belirtilen teslim adresine yapılacaktır. Ürün sevk irsaliyesinde belirtilen teslim adresleri asıl teslimat adresidir.* Sevk irsaliyesinde belirtilen teslim adresi ile sistemde kayıtlı teslim adresi aynı olmalıdır. Başka bir adrese ve alıcıya teslimatlar kabul edilmeyecektir."
        },
        {
          id: "2",
          question: "Kamyoon’un sunduğu temel özellikler nelerdir?",
          answer: "Kamyoon’un sunduğu başlıca özellikler şunlardır:",
          list: [
            {
                id:1,
                text:"Yapay zeka destekli yük eşleştirme"
            },
            {
                id:2,
                text:"Dijital fatura ve belge yönetimi (e-Arşiv Fatura, U-ETDS bildirimi)"
            },
            {
                id:3,
                text:"Sefer maliyeti hesaplama"
            },
            {
                id:4,
                text:"WhatsApp yük grupları"
            },
            {
                id:5,
                text:"Adres bulma ve rota planlama"
            },
            {
                id:6,
                text:"Uygun sigorta bulma"
            },
            {
                id:7,
                text:"Nakliyeciler sitesinin yük ve araç yoğunluk takibi"
            },
            {
                id:8,
                text:"SMS onaylı teslimat"
            },
            {
                id:9,
                text:"Ücretsiz hukuk danışmanlığı"
            },
            {
                id:10,
                text:"Kamyoncu esnafı kredisi"
            },
            {
                id:11,
                text:"Kamyoncu esnafı danışmanlığı"
            }
          ]
        },
        {
          id: "3",
          question: "Kamyoon’a nasıl kayıt olabilirim?",
          answer: "Kamyoon’a kayıt olmak için mobil uygulamayı indirip, telefon numaranızla kayıt olabilirsiniz. Kayıt işlemi sırasında gerekli bilgileri doldurarak ve doğrulama adımlarını tamamlayarak üyeliğinizi oluşturabilirsiniz."
        },
        {
          id: "4",
          question: "Kamyoon, yük eşleştirme dışında başka hangi hizmetleri sunar?",
          answer: "Kamyoon, yük eşleştirme dışında şu hizmetleri sunar:",
          list: [
            {
                id:1,
                text:"Dijital fatura kesme ve yönetimi"
            },
            {
                id:2,
                text:"U-ETDS yük bildirimleri"
            },
            {
                id:3,
                text:"Sefer maliyeti ve diğer lojistik hesaplamalar"
            },
            {
                id:4,
                text:"WhatsApp yük grupları aracılığıyla yük paylaşımı"
            },
            {
                id:5,
                text:"Kamyoncular için uygun sigorta bulma"
            },
            {
                id:6,
                text:"Ücretsiz hukuk danışmanlığı ve mesleki eğitim programları"
            },
            {
                id:7,
                text:"Nakliyeciler sitesindeki yük ve araç yoğunluklarının takibi"
            }
          ]
        },
        {
            id: "5",
            question: "Kamyoon, kamyoncuların meslek saygınlığını nasıl artırıyor?",
            answer: "Kamyoon, kamyoncuların meslek saygınlığını şu yollarla artırır:",
            list: [
              {
                  id:1,
                  text:"Güvenilir ve şeffaf işlemler sunarak"
              },
              {
                  id:2,
                  text:"Mesleki gelişim ve eğitim programları düzenleyerek"
              },
              {
                  id:3,
                  text:"Kamyoncular arasında güçlü bir topluluk ve dayanışma oluşturarak"
              },
              {
                  id:4,
                  text:"Maddi ve manevi destek hizmetleri sağlayarak (ücretsiz hukuk danışmanlığı, esnaf kredileri vb.)"
              }
            ]
          },
          {
            id: "6",
            question: "Kamyoon’un mobil uygulaması hangi platformlarda mevcuttur?",
            answer: "Kamyoon’un mobil uygulaması hem Android hem de iOS platformlarında mevcuttur. Google Play Store ve Apple App Store üzerinden indirilebilir."
          },
          {
            id: "7",
            question: "Kamyoon’un sağladığı ekonomik avantajlar nelerdir?",
            answer: "Kamyoon, kamyonculara şu ekonomik avantajları sağlar:",
            list: [
              {
                  id:1,
                  text:"Toplu indirim anlaşmaları (akaryakıt, sigorta ve bakım hizmetlerinde indirimler)"
              },
              {
                  id:2,
                  text:"Kamyoncu esnafı kredileri"
              },
              {
                  id:3,
                  text:"Maliyet hesaplama araçları ile daha karlı sefer planlaması"
              }
            ]
          },
          {
            id: "8",
            question: "Kamyoon’da yük bulma ve eşleştirme nasıl çalışır?",
            answer: "Kamyoon’un yapay zeka destekli algoritmaları, kamyonculara en uygun yükleri önerir. Kamyoncular, mobil uygulama üzerinden yük arayabilir ve uygun yükleri bulabilirler. Yük sahipleri ile yapılan eşleştirme işlemleri hızlı ve güvenli bir şekilde tamamlanır."
          },
          {
            id: "9",
            question: "U-ETDS yük bildirimleri Kamyoon üzerinden nasıl yapılır?",
            answer: "Kamyoon, Ulaştırma ve Altyapı Bakanlığı'nın yük bildirim sistemi ile entegre çalışarak, kamyoncuların U-ETDS yük bildirimlerini kolaylıkla yapmalarını sağlar. Mobil uygulama üzerinden gerekli bilgileri doldurarak bildirim işlemlerini tamamlayabilirsiniz.",
          },
          {
            id: "10",
            question: "Kamyoon’un sunduğu destek hizmetleri nelerdir?",
            answer: "Kamyoon, kamyonculara şu destek hizmetlerini sunar:",
            list: [
              {
                  id:1,
                  text:"Ücretsiz hukuk danışmanlığı"
              },
              {
                  id:2,
                  text:"Kamyoncu esnafı danışmanlığı"
              },
              {
                  id:3,
                  text:"Mesleki eğitim programları"
              },
              {
                id:4,
                text:"7/24 müşteri desteği"
              }
            ]
          },
          {
            id: "11",
            question: "Kamyoon’un rakiplerinden farkı nedir?",
            answer: "Kamyoon, rakiplerinden şu özelliklerle ayrılır:",
            list: [
              {
                  id:1,
                  text:"Kapsamlı hizmet yelpazesi (yük eşleştirme, dijital fatura, sigorta bulma vb.)"
              },
              {
                  id:2,
                  text:"Mesleki dayanışmayı ve saygınlığı artıran çözümler"
              },
              {
                  id:3,
                  text:"Ücretsiz destek ve danışmanlık hizmetleri"
              },
              {
                id:4,
                text:"Yenilikçi teknolojiler (yapay zeka, dijital belge yönetimi vb.)"
            }
            ]
          },
          {
            id: "12",
            question: "Kamyoon’a yük veren firma olarak nasıl kayıt olabilirim?",
            answer: "Yük veren firma olarak Kamyoon’a kayıt olmak için mobil uygulama veya web portal üzerinden üyelik oluşturabilirsiniz. Firma bilgilerinizi ve gerekli belgeleri doldurarak kayıt işlemini tamamlayabilirsiniz.",
          },
          {
            id: "13",
            question: "Kamyoon’un sunduğu topluluk ve sosyal destek hizmetleri nelerdir?",
            answer: "Kamyoon, kamyoncular arasında güçlü bir topluluk oluşturarak, deneyim paylaşımı ve sosyal destek sağlar. WhatsApp yük grupları, toplu etkinlikler ve sosyal yardımlaşma programları ile kamyoncuların birlikteliğini güçlendirir.",
          },
          {
            id: "14",
            question: "Kamyoon’un mobil uygulaması hangi özellikleri içerir?",
            answer: "Kamyoon’un mobil uygulaması, şu özellikleri içerir:",
            list: [
              {
                  id:1,
                  text:"Yük bulma ve eşleştirme"
              },
              {
                  id:2,
                  text:"Sefer maliyeti hesaplama"
              },
              {
                  id:3,
                  text:"Dijital fatura ve U-ETDS bildirimi"
              },
              {
                id:4,
                text:"WhatsApp yük grupları"
              },
              {
                id:5,
                text:"Adres bulma ve rota planlama"
              },
              {
                id:6,
                text:"Uygun sigorta bulma"
              },
              {
                id:7,
                text:"Nakliyeciler sitesinin yük ve araç yoğunluk takibi"
              },
              {
                id:8,
                text:"SMS onaylı teslimat"
              },
              {
                id:9,
                text:"Ücretsiz hukuk danışmanlığı ve esnaf danışmanlığı"
              }
            ]
          },
          {
            id: "15",
            question: "Kamyoon’un hedefleri nelerdir?",
            answer: "Kamyoon’un hedefleri şunlardır:",
            list: [
              {
                  id:1,
                  text:"Kamyoncuların iş süreçlerini dijitalleştirerek verimliliği artırmak"
              },
              {
                  id:2,
                  text:"Mesleki dayanışmayı ve saygınlığı artırmak"
              },
              {
                  id:3,
                  text:"Lojistik sektöründe yenilikçi çözümler sunarak lider bir platform olmak"
              },
              {
                id:4,
                text:"Kamyoncu esnafının maliyetlerini düşürmek ve gelirlerini artırmak"
              }
            ]
          },
          {
            id: "16",
            question: "Kamyoon’un yurt dışı pazara açılma hedefleri nelerdir?",
            answer: "Kamyoon, Türkiye’de elde ettiği başarıyı yurt dışına taşımayı hedeflemektedir. Orta Doğu, Avrupa ve Asya pazarlarına açılarak, uluslararası lojistik sektöründe de güçlü bir oyuncu olmayı planlamaktadır.",
          },
          {
            id: "17",
            question: "Kamyoon’a kayıtlı kamyoncu ve firma sayısı nedir?",
            answer: "Kamyoon, kısa süre içinde binlerce kamyoncu ve lojistik firmasını bünyesine katmış olup, kullanıcı sayısını hızla artırmaktadır. Güncel kayıtlı kullanıcı sayısı hakkında bilgi almak için Kamyoon’un resmi web sitesini ziyaret edebilirsiniz.",
          },
          {
            id: "18",
            question: "Kamyoon’un sefer maliyeti hesaplama özelliği nasıl çalışır?",
            answer: "Kamyoon’un sefer maliyeti hesaplama özelliği, kamyoncuların taşıma maliyetlerini doğru bir şekilde hesaplamalarına yardımcı olur. Yakıt fiyatları, mesafe, araç tipi ve diğer giderleri dikkate alarak maliyet analizi yapar ve en karlı sefer planlamasını sağlar.",
          },
          {
            id: "19",
            question: "Kamyoon’un sağladığı indirim anlaşmaları nelerdir?",
            answer: "Kamyoon, kamyonculara akaryakıt, sigorta ve bakım hizmetlerinde toplu indirim anlaşmaları sağlar. Bu sayede, operasyonel maliyetler önemli ölçüde azalır ve kamyoncular daha kazançlı çalışabilirler.",
          },
          {
            id: "20",
            question: "Kamyoon’un gelecekteki projeleri nelerdir?",
            answer: "Kamyoon, teknolojik altyapısını sürekli geliştirerek ve kullanıcı taleplerine göre yeni özellikler ekleyerek hizmet yelpazesini genişletmeyi planlamaktadır. Gelecekte, uluslararası lojistik sektörü için de yenilikçi çözümler sunmayı hedeflemektedir.",
          },
      ],

    SSSItemData: null,


    isLoadingGetKKK: false,
    KKKList: [],


    KKKItemData: null,
    aracTypes:[] 
}

export const getAdminSettings = createAsyncThunk("admin/getAdminSettings", async(_,thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/ApplicationsStatusesAndModes/GetStatusesAndModes`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const updateAdminSettings = createAsyncThunk("admin/updateupdateAdminSettingsSettings", async({updatedData, type},thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/ApplicationsStatusesAndModes/UpdateStatusesAndModes`, updatedData)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: `${type} uygulama ayarları başarıyla güncellendi.`, resultType: "success",  btnText1: "Geri Dön"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg:  "Bir hata oluştu lütfen daha sonra tekrar deneyin.", resultType: "error",  btnText1: "Geri Dön"}))
        }
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})



export const getKKK = createAsyncThunk("admin/getKKK", async(_,thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/TermsOfUse/GetTerms`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const addKKK = createAsyncThunk("admin/addKKK", async(item,thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/TermsOfUse/AddTerms`, item)
        thunkApi.dispatch(getKKK())
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const updateKKK = createAsyncThunk("admin/updateKKK", async(item,thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/TermsOfUse/UpdateTerms`, item)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


export const deleteKKK = createAsyncThunk("admin/deleteKKK", async(id,thunkApi)=> {
    try {
        const {data} = await axiosInstance.post(`/TermsOfUse/DeleteTerm`, id)
        if(data.statusCode === 200){
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg: `Kamyoon kullanım kuralı başarıyla silindi.`, resultType: "success",  btnText1: "Geri Dön"}))
        }
        else{
            thunkApi.dispatch(showModal("result"))
            thunkApi.dispatch(setResultModalData({msg:  "Bir hata oluştu lütfen daha sonra tekrar deneyin.", resultType: "error",  btnText1: "Geri Dön"}))
        }
        return id
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getAracTypes = createAsyncThunk("admin/getAracTypes", async(_,thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/TruckAndTrailerTypes/GetTruckTypes`)
        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})

export const getKasaTypes = createAsyncThunk("admin/getKasaTypes", async(_,thunkApi)=> {
    try {
        const {data} = await axiosInstance.get(`/TruckAndTrailerTypes/GetTrailerTypes`)

        return data
    } catch (error) {
        return thunkApi.rejectWithValue(error)
    }
})


const adminSettSlice = createSlice({
    name: "adminSett",
    initialState,
    reducers: {
        getToBeUpdatedAdminSettingsData:(state, action) => {
            state.toBeUpdatedAdminSettingsData = action.payload
        },


        updateSSSListOrder: (state, action)=> {
            state.SSSList = action.payload
        },

        getSSSItemData: (state,action) => {
            state.SSSItemData= action.payload
        },

        //! bu api gelince kaldırılacak
        addSSSItem: (state, action) => {
            const newItem = {id: (state.SSSList.length+1).toString(), ...action.payload }
            state.SSSList = [newItem, ...state.SSSList]
        },

        //! bu api gelince kaldırılacak
        updateSSSItem: (state, action) => {
            const updatedItem = action.payload
            state.SSSList  = state.SSSList.map(item =>{
                if(item.id === updatedItem.id){
                    return {...item, ...updatedItem}
                }
                else{
                    return item
                }
            }) 
        },

        //! bu api gelince kaldırılacak
        deleteSSSItem: (state,action) => {
            state.SSSList = state.SSSList.filter(item => {
                return item.id !== action.payload.id 
            })
        },


        updateKKKListOrder: (statet,action) => {
            statet.KKKList = action.payload
        },

        getKKKItemData: (state,action) => {
            state.KKKItemData = action.payload
        },

        //! bu api gelince kaldırılacak
        adddKKKItem: (state, action) => {
            const newItem = {id: (state.KKKList.length+1).toString(), ...action.payload }
            state.KKKList = [newItem, ...state.KKKList]
        },

        //! bu api gelince kaldırılacak
        updateKKKItem: (state, action) => {
            const updatedItem = action.payload
            state.KKKList  = state.KKKList.map(item =>{
                if(item.id === updatedItem.id){
                    return {...item, ...updatedItem}
                }
                else{
                    return item
                }
            }) 
        },

        //! bu api gelince kaldırılacak
        deleteKKKItem: (state,action) => {
            state.KKKList = state.KKKList.filter(item => {
                return item.id !== action.payload.id 
            })
        },


    },
    extraReducers:(builder)=> {
        builder
            .addCase(getAdminSettings.pending, (state)=> {
                state.isLoadingGetSetttings = true
            })

            .addCase(getAdminSettings.fulfilled, (state, action)=> {
                state.isLoadingGetSetttings = false
                state.settingsData = action.payload.data
            })

            .addCase(getAdminSettings.rejected, (state, action)=> {
                state.isLoadingGetSetttings = false
            })

            .addCase(getKKK.pending, (state)=> {
                state.isLoadingGetKKK = true
            })
            .addCase(getKKK.fulfilled, (state, action)=> {
                state.isLoadingGetKKK = false
                const list = action.payload.data.$values
                const sorted = list.sort((a, b) => a.termsOrder - b.termsOrder)

                const data = sorted.map((item) => {
                    return {...item, id: item.id.toString()}
                })
                state.KKKList = data
            })
            .addCase(getKKK.rejected, (state, action)=> {
                state.isLoadingGetKKK = false
            })
            
            .addCase(addKKK.pending, (state)=> {
                state.isLoadingGetKKK = true
            })
            .addCase(addKKK.fulfilled, (state, action)=> {
                state.isLoadingGetKKK = false
            })
            .addCase(addKKK.rejected, (state, action)=> {
                state.isLoadingGetKKK = false
            })

            .addCase(deleteKKK.pending, (state)=> {
                state.isLoadingGetKKK = true
            })
            .addCase(deleteKKK.fulfilled, (state, action)=> {
                const {id } = action.payload
                state.KKKList = state.KKKList.filter((item) => {
                    return item.id.toString() !== id.toString() 
                })
            })
            .addCase(deleteKKK.rejected, (state, action)=> {
                state.isLoadingGetKKK = false
            })

            // get arac types
            .addCase(getAracTypes.pending, (state)=> {
            })
            .addCase(getAracTypes.fulfilled, (state, action)=> {
                state.aracTypes = action.payload.data.$values
                
            })
            .addCase(getAracTypes.rejected, (state, action)=> {
            })

    }
})


export const {getToBeUpdatedAdminSettingsData, updateSSSListOrder, getSSSItemData, addSSSItem, updateSSSItem, deleteSSSItem, updateKKKListOrder, getKKKItemData, adddKKKItem, updateKKKItem, deleteKKKItem } = adminSettSlice.actions
export default adminSettSlice.reducer